module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Building-88f8fc4b3a356efa635bf4c3c3819073.svg";